<template>
  <v-container>
    <v-card elevation="0" width="100%" height="100%">
      <v-card-title style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">รายชื่อลูกค้า</v-card-title>
      <v-card-title class="px-0" style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;" v-else>
        <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> รายชื่อลูกค้า
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <v-row :class="MobileSize || IpadSize || IpadProSize ? 'mt-1' : 'my-2'">
            <v-col cols="12" align="end" class="pt-2" v-if="!MobileSize && !IpadSize && !IpadProSize">
              <v-btn width="210" class="ml-1" color="#27AB9C" dark outlined @click="changeSalesData()"><v-icon small>mdi-file-download-outline</v-icon>เปลี่ยนแปลงข้อมูลฝ่ายขาย</v-btn>
              <v-btn width="213" class="ml-1" color="#27AB9C" dark outlined :href="PathDownloadForm"><v-icon small>mdi-download</v-icon>ดาวน์โหลดฟอร์มนำเข้าข้อมูล</v-btn>
              <v-btn width="103" class="ml-1" color="#27AB9C" dark outlined @click="$refs.file_input.click()"><v-icon small>mdi-file-upload-outline</v-icon>นำเข้าข้อมูล</v-btn>
              <v-btn width="103" class="ml-1" color="#27AB9C" dark outlined @click="exportExcel()" :href="ExportFile"><v-icon small>mdi-file-download-outline</v-icon>Export</v-btn>
              <v-btn width="101" class="ml-1" color="#27AB9C" dark @click="addCustomerData()"><v-icon small>mdi-plus</v-icon>เพิ่มข้อมูล</v-btn>
            </v-col>
            <v-col cols="12" class="pt-2" v-else>
              <v-row>
                <v-col :cols="IpadProSize ? 6 : 12">
                  <v-btn block color="#27AB9C" dark outlined @click="changeSalesData()"><v-icon small>mdi-file-download-outline</v-icon>เปลี่ยนแปลงข้อมูลฝ่ายขาย</v-btn>
                </v-col>
                <v-col :cols="IpadProSize ? 6 : 12">
                  <v-btn block color="#27AB9C" dark outlined :href="PathDownloadForm"><v-icon small>mdi-download</v-icon>ดาวน์โหลดฟอร์มนำเข้าข้อมูล</v-btn>
                </v-col>
                <v-col :cols="IpadProSize || IpadSize ? 4 : 12">
                  <v-btn block color="#27AB9C" dark outlined @click="$refs.file_input.click()"><v-icon small>mdi-file-upload-outline</v-icon>นำเข้าข้อมูล</v-btn>
                </v-col>
                <v-col :cols="IpadProSize || IpadSize ? 4 : 12" :class="IpadSize ? 'pr-0' : ''">
                  <v-btn block color="#27AB9C" dark outlined @click="exportExcel()" :href="ExportFile" ><v-icon small>mdi-file-download-outline</v-icon>Export</v-btn>
                </v-col>
                <v-col :cols="IpadProSize || IpadSize ? 4 : 12">
                  <v-btn block color="#27AB9C" dark @click="addCustomerData()"><v-icon small>mdi-plus</v-icon>เพิ่มข้อมูล</v-btn>
                </v-col>
              </v-row>
            </v-col>
            <input type="file" @click="event => event.target.value = null" @change="previewFiles($event)" ref="file_input" accept=".xls, .xlsx" style="display: none;"/>
          </v-row>
          <v-row>
            <v-col :cols="MobileSize || IpadSize || IpadProSize ? 12 : 6" :class="MobileSize || IpadSize || IpadProSize ? 'mt-1 mb-3' : 'mb-3 pt-0'">
              <v-text-field v-model="search" placeholder="ค้นหารายชื่อลูกค้า" outlined dense hide-details>
                <v-icon slot="append" color="#27AB9C">mdi-magnify</v-icon>
              </v-text-field>
            </v-col>
          </v-row>
          <v-col cols="12" v-if="disableTable === false" class="pt-0">
            <v-row dense>
              <v-col cols="12" class="mt-4">
                <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600">รายชื่อลูกค้าทั้งหมด {{ showCountCustomer }} รายการ</span>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" v-if="disableTable === false" class="mt-5">
            <v-data-table
            :headers="headers"
            :items="customerList"
            :search="search"
            :page.sync="page"
            @pagination="countCustomer"
            no-results-text="ไม่พบรายชื่อลูกค้า"
            no-data-text="ไม่มีรายชื่อลูกค้าในตาราง"
            :footer-props="{'items-per-page-text':'จำนวนแถว'}"
            @update:items-per-page="itemsPerPage"
            :items-per-page="10"
            class="elevation-1"
            >
              <template v-slot:[`item.created_at`]="{ item }">
                {{  formatDateTH(item.created_at) }}
              </template>
              <template v-slot:[`item.manages`]="{ item }">
                <v-row>
                    <v-col cols="12">
                      <v-btn class="d-inline-block" text rounded color="#27AB9C" :class="!MobileSize? 'px-2' : 'pa-0 ma-0'" small @click="customerDetail(item.cus_id)">
                        <v-icon small>mdi-file-document-outline</v-icon>
                        <span>รายละเอียด</span>
                      </v-btn>&nbsp;&nbsp;
                      <span class="d-inline-block" style="color: #F5222D; font-size: 12px;">{{ item.note_address }}</span>
                    </v-col>
                  </v-row>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12" v-else>
            <v-row justify="center" align-content="center">
              <v-col cols="12" md="12" align="center">
                <div class="my-5">
                  <v-img src="@/assets/Gracz/Customer/emptyGroupCustomer.png" max-height="500px" max-width="500px" height="100%" width="100%" contain aspect-ratio="2"></v-img>
                </div>
                <h2 style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;"><b>คุณยังไม่มีรายชื่อลูกค้า</b></h2>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-overlay :value="loading" style="text-align:center; z-index: 99999;">
      <v-card width="450px" height="150px" class="pa-3" color="white" style="opacity: 80%;">
        <v-progress-circular indeterminate size="64" color="#00B500"></v-progress-circular>
        <p style="font-weight: 600; font-size: 18px; line-height: 24px; color: #333333; margin-top: 30px;">กำลังดาวน์โหลด กรุณารอสักครู่</p>
      </v-card>
    </v-overlay>
    <ModalManageCustomerData ref="ModalManageCustomerData" />
    <ModalChangeSalesData ref="ModalChangeSalesData" />
  </v-container>
</template>
<script>
import { Decode, Encode } from '@/services'
import * as XLSX from 'xlsx/xlsx.mjs'
import moment from 'moment'
export default {
  components: {
    ModalManageCustomerData: () => import('@/components/Gracz/Admin/Customer/Modal/ManageCustomerDataModal'),
    ModalChangeSalesData: () => import('@/components/Gracz/Admin/Customer/Modal/ChangeSalesDataModal')
  },
  data () {
    return {
      file: null,
      PathDownloadForm: '',
      ExportFile: '',
      stateStatus: 0,
      showCountCustomer: 0,
      page: 1,
      itemsPerPage: 10,
      customerList: [],
      disableTable: true,
      search: '',
      headers: [
        { text: 'รหัสลูกค้า', value: 'cus_code', sortable: false, width: '70px', class: 'backgroundTable fontTable--text' },
        { text: 'ชื่อลูกค้า', value: 'cus_name', sortable: false, width: '190px', class: 'backgroundTable fontTable--text' },
        { text: 'รหัสฝ่ายขาย', value: 'sales_code', sortable: false, width: '90px', class: 'backgroundTable fontTable--text' },
        { text: 'วันที่สร้าง', value: 'created_at', sortable: false, width: '140px', class: 'backgroundTable fontTable--text' },
        { text: 'กลุ่มลูกค้า', value: 'channel_name', sortable: false, width: '100px', class: 'backgroundTable fontTable--text' },
        { text: 'จัดการ', value: 'manages', sortable: false, width: '220px', class: 'backgroundTable fontTable--text' }
      ],
      userDetailSelling: '',
      customerData: '',
      importCustomer: [],
      loading: false,
      shop: ''
    }
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push('/Order/CustomerListMobile').catch(() => {})
      } else {
        this.$router.push('/Order/CustomerList').catch(() => {})
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.$EventBus.$on('getCustomerList', this.getData)
    this.$on('hook:beforeDestroy', () => {
      this.$EventBus.$off('getCustomerList')
    })
  },
  created () {
    // this.$EventBus.$emit('changeNav')
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      if (localStorage.getItem('UserDetailSelling') !== null) {
        this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
        // console.log('VV', this.userDetailSelling)
        this.ExportFile = process.env.VUE_APP_BACK_END + 'api/g/export_excel_customer_file?seller_shop_id=' + this.userDetailSelling.seller_shop_id
      }
      if (localStorage.getItem('OnlinePurchase') !== null) {
        this.customerData = JSON.parse(Decode.decode(localStorage.getItem('OnlinePurchase')))
      }
      this.checkShop()
      if (this.shop === 'Gracz') {
        this.PathDownloadForm = process.env.VUE_APP_BACK_END + 'api/g/export_excel_customer_form'
      } else {
        this.PathDownloadForm = process.env.VUE_APP_BACK_END + 'api/g/so_export_excel_customer_form'
      }
      this.getData()
    }
  },
  methods: {
    checkShop () {
      if (this.userDetailSelling.is_gracz === 'yes') {
        this.shop = 'Gracz'
      } else {
        if (this.userDetailSelling.is_rattana === 'yes') {
          this.shop = 'Rattana'
        } else {
          this.shop = 'Sale Order'
        }
      }
    },
    previewFiles (e) {
      var files = e.target.files
      var f = files[0]
      // var dataJ
      var reader = new FileReader()
      reader.onload = (e) => {
        var data = new Uint8Array(e.target.result)
        var workbook = XLSX.read(data, { type: 'array' })
        const sheetName = workbook.SheetNames[0]
        /* DO SOMETHING WITH workbook HERE */
        const worksheet = workbook.Sheets[sheetName]
        this.importCustomerData(XLSX.utils.sheet_to_json(worksheet))
      }
      reader.readAsArrayBuffer(f)
    },
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/SellerShopMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/SellerShop' }).catch(() => {})
      }
    },
    async getData () {
      this.$store.commit('openLoader')
      // var shopData = this.userDetailSelling
      // console.log('shopData', this.userDetailSelling)
      const data = {
        seller_shop_id: this.userDetailSelling.seller_shop_id
      }
      await this.$store.dispatch('actionsGraczCustomerSellerList', data)
      var response = await this.$store.state.ModuleGraczCustomer.stateGraczCustomerSellerList
      if (response.message === 'Get list customer success.') {
        this.$store.commit('closeLoader')
        if (response.data.length !== 0) {
          this.customerList = response.data.active_customer
          this.disableTable = false
        } else {
          this.disableTable = true
        }
      } else {
        this.$store.commit('closeLoader')
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    customerDetail (val) {
      var cusid = val
      if (this.MobileSize) {
        this.$router.push(`/Order/CustomerDetailMobile?cusid=${cusid}`).catch(() => {})
      } else {
        this.$router.push(`/Order/CustomerDetail?cusid=${cusid}`).catch(() => {})
      }
    },
    addCustomerData () {
      this.$refs.ModalManageCustomerData.open('เพิ่มข้อมูลลูกค้า')
    },
    onPickFile () {
      localStorage.removeItem('previewCheckImportCustomer')
      document.getElementById('file_input').click()
    },
    uploadExcel () {
      this.importCustomerData()
    },
    async importCustomerData (excelJson) {
      this.$store.commit('openLoader')
      var shopData = this.userDetailSelling
      var sendData
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        file: excelJson
      }
      await this.$store.dispatch('actionsGraczImportCustomerData', data)
      var response = await this.$store.state.ModuleGraczCustomer.stateGraczImportCustomerData
      if (response.code !== 500) {
        if (response.message === 'Create customer data from excel file successfully.') {
          this.$store.commit('closeLoader')
          this.$swal.fire({ icon: 'success', text: 'นำเข้าข้อมูลลูกค้าจากไฟล์ Excel สำเร็จ', showConfirmButton: false, timer: 2000 })
          sendData = { response: response.message, data: response.data }
          await localStorage.setItem('previewCheckImportCustomer', Encode.encode(sendData))
          this.goToPreviewImportExcel()
        } else {
          this.$store.commit('closeLoader')
          if (response.message === 'Fail to upload customer data from excel file.') {
            this.$swal.fire({ icon: 'warning', text: 'ไม่สามารถนำเข้าข้อมูลลูกค้าจากไฟล์ Excel ได้ (ข้อมูลในไฟล์มีข้อผิดพลาด)', showConfirmButton: false, timer: 2000 })
            sendData = { response: response.message, data: response.data }
            await localStorage.setItem('previewCheckImportCustomer', Encode.encode(sendData))
            // await this.$store.dispatch('actionsGraczSetFile', this.importCustomer)
            this.goToPreviewImportExcel()
          } else if (response.message === 'This user is unauthorized.') {
            this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
            window.location.assign('/')
          } else if (response.message === 'Not access this function.') {
            this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
            window.location.assign('/')
          } else {
            var [msg, iconMsg] = this.getErrorMsg(response.message)
            this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
          }
        }
      } else {
        this.$store.commit('closeLoader')
        this.$swal.fire({ icon: 'warning', text: 'ไม่สามารถนำเข้าข้อมูลลูกค้าจากไฟล์ Excel ได้ (ข้อมูลในไฟล์มีข้อผิดพลาด)', showConfirmButton: false, timer: 2000 })
      }
    },
    goToPreviewImportExcel () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/ImportCustomerDataMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/ImportCustomerData' }).catch(() => {})
      }
    },
    async exportExcel () {
      this.loading = true
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id
      }
      await this.$store.dispatch('actionsGraczCustomerExcelExportGetLoading', data)
      var response = await this.$store.state.ModuleGraczCustomer.stateGraczCustomerExportGetLoading
      if (response.message === 'Export customer excel successfully.') {
        this.loading = false
      } else if (response.message === 'This user is unauthorized.') {
        this.loading = false
        this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      } else if (response.message === 'Not access this function.') {
        this.loading = false
        this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      } else {
        this.loading = false
        var [msg, iconMsg] = this.getErrorMsg(response.message)
        this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
      }
    },
    formatDateTH (date) {
      var year = moment(date).locale('TH').add('Year', 543).format('YYYY')
      var dateTH = moment(date).locale('TH').format('D MMMM ' + year)
      return dateTH
    },
    getErrorMsg (msg) {
      if (msg === 'This user is unauthorized.') {
        return ('กรุณาเข้าสู่ระบบใหม่อีกครั้ง', 'warning')
      } else if (msg === 'Data missing. Please check your parameter and try again.') {
        return ['ข้อมูลขาดหาย', 'warning']
      } else if (msg === 'Not access this function.') {
        return ['มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Employee not found. Please check and try again.') {
        return ['ไม่พบพนักงาน โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Seller shop not found.' || msg === 'Not Found Seller Shop') {
        return ['ไม่พบร้านค้า', 'warning']
      } else if (msg === 'Parameter Missing. Please check and try again.') {
        return ['ข้อมูลขาดหาย โปรดลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Customer in this shop not found.') {
        return ['ไม่พบลูกค้าในร้านนี้', 'warning']
      } else if (msg === 'Fail to upload file.') {
        return ['ไม่สามารถนำเข้าข้อมูลลูกค้าจากไฟล์ได้', 'warning']
      } else if (msg === 'Data have not more than 400') {
        return ['ไม่สามารถนำเข้าข้อมูลลูกค้าที่มากกว่า 400 รายการได้', 'warning']
      } else {
        return [msg, 'error']
      }
    },
    changeSalesData () {
      this.$refs.ModalChangeSalesData.open()
    },
    countCustomer (pagination) {
      this.showCountCustomer = pagination.itemsLength
    }
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep table {
    tbody {
      tr {
        td:nth-child(6) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 10;
          background: white;
        }
      }
    }
    thead {
      tr {
        th:nth-child(6) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 0;
          z-index: 11;
          background: white;
          // outline: 2px solid rgba(255, 255, 255, 0.83);
        }
      }
    }
  }
  ::v-deep .elevation-1 th:first-of-type {
    background-color: #E6F5F3;
  }
</style>
